/*
    Component -> ngoModalSearcher
    Component to create NGO Modal searcher to show
    more information about this.
    Also can select NGO to hire cards and transfers components
*/

require("./ngoModalSearcher.scss");

// @vendors
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
const filterLodash = require("lodash/collection/filter");
const isEmpty = require("lodash/lang/isEmpty");
const { sortBy } = require("lodash/collection");
import lodash from "lodash";

// @common-components
import { ModalCustom } from "commonsComponents/modalCustom";
import { OKButton } from "commonsComponents/OKButton";
import { OKIconTask } from "commonsComponents/OKIconTask";
import { RadioButtonGroup } from "commonsComponents/radioButtonGroup";
import { HTMLSafeInjector } from "commonsComponents/htmlSafeInjector";

// @components
import { OKAutosuggest } from "commonsComponents/OKAutosuggest";

// @utils
const { getPublicSiteUrl } = require("core/apiURLBuilder");
import apiURLBuilder from "core/apiURLBuilder";
import { i18n } from "core/i18n";
const { FormattedText, formatText } = i18n;
const {
    getFirstNChars,
    capitalizeFirstLetter,
    toCamelCase
} = require("utilities/stringHelper");
const { getLanguage } = require("core/i18n").i18n;
const {
    recordLink,
    PROC_INTERACTION_NGO,
    PROC_SHOW_DETAILS_NGO,
    PROC_TRANSFER
} = require("utilities/tagging");

// @constants
import { NGO_MODAL_CARD } from 'constants/index';
import { COLOR_CATEGORY_DEFAULT } from 'constants/colors';

// @api
import { APIGet } from "utilities/APIRequestHelper";

export class NGOModalSearcher extends Component {
    constructor(props) {
        super(props);

        this.state = {
            openModal: props.openModal,
            charityFoundationsSourceError: false,
            filter: 0,
            stringSearch: "",
            viewFoundationDetail: false,
            charityFoundationSelected: {},
            fixedContainer: false,
            detailNGO: "",
            categoriesOrdered: [],
            topModalDetail: 0
        };

        this.getPublicUrlWithoutLanguageParam = this.getPublicUrlWithoutLanguageParam.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        let categories = [];
        for (
            let i = 0;
            i < sortBy(nextProps.charityFoundations, o => o.ngoId).length;
            i += 1
        ) {
            for (
                let j = 0;
                j < nextProps.charityFoundations[i].categories.length;
                j += 1
            ) {
                categories.push(nextProps.charityFoundations[i].categories[j]);
            }
        }

        if (nextProps.openModal) {
            this.setState({
                openModal: true,
                categoriesOrdered: sortBy(
                    lodash.uniq(categories, "ngoCategoryId"),
                    o => o.ngoCategoryId
                )
            });
        }
    }

    // Function to open and close modal and clear the value of filters and searcher
    openModalNGO() {
        const { closeModal } = this.props;
        const { openModal } = this.state;

        recordLink(PROC_INTERACTION_NGO, PROC_SHOW_DETAILS_NGO);

        closeModal(!openModal);

        this.setState({
            openModal: !openModal,
            filter: 0,
            stringSearch: "",
            viewFoundationDetail: false,
            fixedContainer: false
        });
    }

    // Function to change filter value
    handleFilterChange = filter => {
        this.setState({
            filter,
            stringSearch: ""
        });
    };

    // Function to select NGO
    handleSelectFoundation = () => {
        const { charityFoundationSelected } = this.state;
        const { changeCharityFoundation } = this.props;
        recordLink(
            PROC_INTERACTION_NGO,
            PROC_TRANSFER,
            charityFoundationSelected.suggestion.name
        );

        changeCharityFoundation(charityFoundationSelected);

        this.setState({
            openModal: false
        });
    };

    // Function to close detail view
    closeViewFoundationDetail = () => {
        this.setState({
            viewFoundationDetail: false,
            fixedContainer: false,
            topModalDetail:0
        });
    };

    // Name Helper
    changeNameTextFormat = (name, id) => {
        let nameNGO = name;

        if (id !== 5) {
            nameNGO =
                id === 10 ? toCamelCase(name) : capitalizeFirstLetter(name);
            nameNGO = id === 15 ? nameNGO.replace(/\s/g, "") : nameNGO;
            nameNGO = id === 23 ? toCamelCase(name): nameNGO;
            nameNGO =
                id === 13
                    ? nameNGO
                          .split("")
                          .map((v, i) => (i === 9 ? v.toUpperCase() : v))
                          .join("")
                    : nameNGO;
        }

        return nameNGO;
    };

    // Function to open detail view
    handleViewFoundationDetail = value => {
        const language = getLanguage().toUpperCase();
        const baseURL = apiURLBuilder.getURL("campaignEngine");
        const idNGO = value.suggestion.uniquename;
        recordLink(
            PROC_INTERACTION_NGO,
            "mas informacion",
            value.suggestion.name
        );

        APIGet(() => {}, `${baseURL}/default/${language}/solidario-${idNGO}/1`)
            .then(response => {
                this.setState({
                    detailNGO: response[0].body.value,
                    viewFoundationDetail: true,
                    charityFoundationSelected: value,
                    fixedContainer: true,
                    topModalDetail:
                        this.modalNgo &&
                        this.modalNgo.offsetParent &&
                        this.modalNgo.offsetParent.scrollTop
                });
            })
            .catch(response => {
                this.setState({
                    detailNGO: response
                });
            });
    };

    // Function to change searcher value
    handleChangeSearcher = value => {
        const { filter } = this.state;
        const searcherIsEmpty = value === "";

        this.setState({
            filter: searcherIsEmpty ? filter : 0,
            stringSearch: searcherIsEmpty ? "" : value
        });
    };

    // Function to build searchear
    buildInputSearch = () => {
        const { stringSearch } = this.state;
        const { charityFoundations } = this.props;

        return (
            <div className="ngo-modal-searcher__searcher col-xs-8">
                <OKAutosuggest
                    valueModal={stringSearch}
                    onChange={this.handleChangeSearcher}
                    dataset={charityFoundations}
                    isCharity={true}
                    content="name"
                    format="modal"
                />
            </div>
        );
    };

    getPublicUrlWithoutLanguageParam = () => {
        let publicSiteUrl = getPublicSiteUrl();

        if (!!publicSiteUrl && publicSiteUrl.slice(publicSiteUrl.length - 3, -2) === "/") {
            publicSiteUrl = publicSiteUrl.slice(0, -3);
        }
        return publicSiteUrl;
    }

    // Function to get the filters from the all foundatios that we have
    buildFilters = () => {
        const { filter, categoriesOrdered } = this.state;
        let filters = [];

        categoriesOrdered.map(category => {
            const classFilter = classNames("ngo-modal-searcher__radio-filter", {
                "ngo-modal-searcher__filters-container-selected":
                    category.ngoCategoryId === filter
            });

            filters.push(
                <div
                    className="ngo-modal-searcher__filters-container"
                    onClick={() =>
                        this.handleFilterChange(parseInt(category.ngoCategoryId))
                    }
                >
                    <div
                        className={'ngo-modal-searcher__filter-circle'} style={{ border: `1px solid ${category.color || COLOR_CATEGORY_DEFAULT}`}}
                    >
                        <img src={this.getPublicUrlWithoutLanguageParam() + category.image} />
                    </div>
                    <div className={classFilter}>
                        <FormattedText
                            value={`ngoCategory-${category.ngoCategoryId}Name`}
                        />
                    </div>
                </div>
            );
        });

        if (filter !== 0) {
            // we add "all filters" option when there are not any filter selected
            filters.push(
                <div className="ngo-modal-searcher__button-all">
                    <OKButton
                        modifier="link-emphasize"
                        size="small"
                        onClick={() => this.handleFilterChange(0)}
                    >
                        <FormattedText value={"ngoCategory-allName"} />
                    </OKButton>
                </div>
            );
        }

        // return all the radiobuttons for filtres
        return (
            <div className="col-xs-12 col-md-4 col-lg-3 ngo-modal-searcher__sticky-filters">
                <RadioButtonGroup
                    name="ngoFilters"
                    idPrefix="ngoFiltersRadioButtons"
                    selectedValue={filter}
                    onChange={this.handleFilterChange}
                >
                    {filters}
                </RadioButtonGroup>
            </div>
        );
    };

    // Function to build boxes and clasiffied this for categories or searcher value
    buildCategoriesBoxes = () => {
        const { filter, stringSearch, categoriesOrdered } = this.state;
        const { charityFoundations } = this.props;
        const stringStrinEmpty = stringSearch === "";

        let boxCategories = [];
        let boxNotToShow = [];
        let boxes = [];
        let imageBoxCategory;
        let nameBoxCategory;
        let noResults;
        let onlyOneCategory = false;
        let repeatSearch = true;

        categoriesOrdered.map((category, index) => {
            if (stringStrinEmpty && filter === 0) {
                boxes = filterLodash(charityFoundations, function(foundation) {
                    return (
                        foundation.categories.filter(
                            obj => obj.ngoCategoryId === category.ngoCategoryId
                        ).length > 0
                    );
                });
            } else if (
                !stringStrinEmpty &&
                filter === 0 &&
                stringSearch !== null &&
                stringSearch !== undefined
            ) {
                boxes = filterLodash(charityFoundations, function(foundation) {
                    return foundation.name
                        .toLowerCase()
                        .includes(stringSearch.toLowerCase());
                });
            } else if (stringStrinEmpty && filter !== 0) {
                onlyOneCategory = true;
                boxes = filterLodash(charityFoundations, function(foundation) {
                    return (
                        foundation.categories.filter(
                            obj => obj.ngoCategoryId === filter
                        ).length > 0
                    );
                });
            }

            if (boxes.length === 0 && index < 1) {
                //if there are not results for searcher, create text with message warning
                const injectedStrings = [stringSearch];
                noResults = (
                    <div className="ngo-modal-searcher__no-results-container">
                        <FormattedText
                            value="ngoModal-noResults"
                            injectedStrings={injectedStrings}
                        />
                        <FormattedText value="ngoModal-noResultsInformation" />
                    </div>
                );
                boxes = charityFoundations; //all the boxes appears now
            } else {
                noResults = null;
            }

            let boxesInformation;
            if (repeatSearch) {
                boxesInformation = boxes.map((foundation, index) => {
                    if (!boxNotToShow.includes(foundation.ngoId)) {
                        const valuesReturn = {
                            suggestion: {
                                ...foundation
                            }
                        };
                        boxNotToShow.push(foundation.ngoId);

                        return (
                            <div
                                className="col-xs-6 col-md-6 col-lg-4 ngo-modal-searcher__foundation-box"
                                key={index.toString()}
                            >
                                <div className="ngo-modal-searcher__foundation-box-shadow">
                                    <div className="ngo-modal-searcher__foundation-image">
                                        <img
                                            src={
                                                this.getPublicUrlWithoutLanguageParam() +
                                                foundation.image
                                            }
                                            alt={foundation.name}
                                            title={foundation.name}
                                        />
                                    </div>
                                    <div className="ngo-modal-searcher__foundation-information">
                                        <h4 className="ngo-modal-searcher__foundation-name">
                                            {this.changeNameTextFormat(
                                                foundation.name,
                                                foundation.ngoId
                                            )}
                                        </h4>
                                        <div className="ngo-modal-searcher__foundation-description">
                                            {foundation.uniquename && getFirstNChars(
                                                formatText(
                                                    `ngoDescriptionModal-${foundation.uniquename.replace(
                                                        /_/g,
                                                        ""
                                                    )}`
                                                ),
                                                90
                                            )}
                                        </div>
                                        <div className="ngo-modal-searcher__button-view-more-container">
                                            <OKButton
                                                modifier="secondary"
                                                onClick={() =>
                                                    this.handleViewFoundationDetail(
                                                        valuesReturn
                                                    )
                                                }
                                            >
                                                <FormattedText
                                                    value={
                                                        "ngoModal-viewMoreDetail"
                                                    }
                                                />
                                            </OKButton>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    }
                });
            }

            if (!stringStrinEmpty) repeatSearch = false;

            const createFilter = filter !== 0 && category.ngoCategoryId === filter;
            imageBoxCategory = this.getPublicUrlWithoutLanguageParam() + category.image;
            nameBoxCategory = `ngoCategory-${category.ngoCategoryId}Name`;
            onlyOneCategory = createFilter ? false : onlyOneCategory;

            if (!onlyOneCategory) {
                boxCategories.push(
                    <Fragment>
                        {stringStrinEmpty && (
                            <div className="ngo-modal-searcher__container-category">
                                <div className="col-xs-12 ngo-modal-searcher__box-category" style={{ borderLeft: `2px solid ${category.color || COLOR_CATEGORY_DEFAULT}`}}>
                                    <img src={imageBoxCategory} />
                                    <FormattedText value={nameBoxCategory} />
                                </div>
                            </div>
                        )}
                        {noResults}
                        {boxesInformation}
                    </Fragment>
                );
            }

            boxNotToShow = [];
        });

        return boxCategories;
    };

    // Build message to show if NGO is deductible or not
    buildMessageNGO = () => {
        const { charityFoundationSelected } = this.state;
        const isDeductible = isEmpty(charityFoundationSelected)
            ? false
            : !charityFoundationSelected.suggestion.deductible;

        return (
            <div className="ngo-modal-searcher__message-ngo col-xs-7">
                {isDeductible && (
                    <FormattedText value="ngoModal-adviseNGODeductible" />
                )}
            </div>
        );
    };

    buildButtonShowModal = () => {
        const { showButton } = this.props;
        const button = showButton ? (
            <OKButton
                modifier="link-emphasize"
                size="small"
                onClick={() => this.openModalNGO()}
            >
                <FormattedText value={"ngoModal-buttonModal"} />
            </OKButton>
        ) : null;

        return button;
    };

    // Build detail for NGO
    buildNGODetail = () => {
        const { typeNGOModal } = this.props;
        const {
            viewFoundationDetail,
            charityFoundationSelected,
            detailNGO
        } = this.state;
        let hasbody = detailNGO !== undefined;

        if (!isEmpty(charityFoundationSelected)) {
            const message = this.buildMessageNGO();
            const selectButtonText =
                typeNGOModal === "card"
                    ? "ngoModal-addCardNGO"
                    : "ngoModal-addTransferNGO";
            const injectedStrings = [
                this.changeNameTextFormat(
                    charityFoundationSelected.suggestion.name,
                    charityFoundationSelected.suggestion.ngoId
                )
            ];
            const classDetail = classNames(
                "col-xs-12 ngo-modal-searcher__foundation-modal-detail-hidden",
                {
                    "ngo-modal-searcher__foundation-modal-detail-show": viewFoundationDetail,
                    "ngo-modal-searcher__title-inherit":
                        charityFoundationSelected.suggestion.ngoId === 5
                }
            );

            const classFooter = classNames(
                "ngo-modal-searcher__foundation-modal-detail-body-container",
                {
                    "-hidden": !viewFoundationDetail,
                }
            );

            return (
                <div className={classDetail}>
                    <div className="ngo-modal-searcher__foundation-modal-detail-header">
                        <div>
                            <span
                                className="ngo-modal-searcher__return-button-detail"
                                onClick={() => this.closeViewFoundationDetail()}
                            >
                                <i className="icon icon-anterior" />
                                <FormattedText value="ngoModal-viewAllNgo" />
                            </span>
                        </div>
                        <div className="ngo-modal-searcher__foundation-modal-detail-header-image-container row">
                            <div className="col-xs-2">
                                <img
                                    src={
                                        this.getPublicUrlWithoutLanguageParam() +
                                        charityFoundationSelected.suggestion
                                            .imagelogo
                                    }
                                />
                            </div>
                            <div className="col-xs-10 ngo-modal-searcher__foundation-modal-detail-header-image-container-information">
                                <h2 className="ngo-modal-searcher__foundation-modal-detail-header-title">
                                    {this.changeNameTextFormat(
                                        charityFoundationSelected.suggestion
                                            .name,
                                        charityFoundationSelected.suggestion
                                            .ngoId
                                    )}
                                </h2>
                            </div>
                        </div>
                    </div>
                    <button
                        className="custom-modal__close-icon icon-cerrar ngo-modal-searcher__foundation-modal-detail-close"
                        onClick={() => this.openModalNGO()}
                    />
                    <div className="ngo-modal-searcher__foundation-modal-detail-body-footer-container">
                        <div className="ngo-modal-searcher__foundation-modal-detail-body">
                            <div className="row ngo-modal-searcher__foundation-modal-detail-body-text">
                                {hasbody && (
                                    <HTMLSafeInjector
                                        customClass="row ngo-modal-searcher__margin-scroll"
                                        message={detailNGO}
                                    />
                                )}
                                {!hasbody && (
                                    <FormattedText value="ngoModal-noBodyDetail" />
                                )}

                            </div>
                        </div>
                        <div className={classFooter}>
                            {message}
                            <div className="ngo-modal-searcher__foundation-modal-detail-body-button col-xs-5">
                                <OKButton onClick={this.handleSelectFoundation}>
                                    <FormattedText
                                        value={selectButtonText}
                                        injectedStrings={injectedStrings}
                                    />
                                </OKButton>
                            </div>
                        </div>
                    </div>



                </div>
            );
        } else {
            return null;
        }
    };

    render() {
        const { openModal, fixedContainer, topModalDetail } = this.state;
        const { typeNGOModal } = this.props;
        const filters = this.buildFilters();
        const NGOboxes = this.buildCategoriesBoxes();
        const inputSearch = this.buildInputSearch();
        const NGOdetail = this.buildNGODetail();
        const buttonShowModal = typeNGOModal === NGO_MODAL_CARD && this.buildButtonShowModal();

        const classModal = classNames(
            "row ngo-modal-searcher__modal-container",
            {
                "ngo-modal-searcher__modal-container-fixed": fixedContainer
            }
        );

        const classModalScroll = classNames("ngo-modal-searcher__modal", {
            "ngo-modal-searcher__modal-no-scroll": fixedContainer
        });

        const modalContainerClass = classNames(
            "row",
            "ngo-modal-searcher__modal-container"
        );

        const containerFiltersBoxesClass = classNames("row ngo-modal-searcher__container-filters-boxes", {
            "-hiden-filter-boxes": fixedContainer
        })

        const bottomMessageClass = classNames("row ngo-modal-searcher__bottom-message", {
            "-hidden-bottom-message": fixedContainer
        })

        return (
            <div className="ngo-modal-searcher">
                {buttonShowModal}
                <ModalCustom
                    extraClass={classModalScroll}
                    isOpen={openModal}
                    shouldCloseOnOverlayClick={true}
                    scrollable={true}
                >
                    <div
                        className={modalContainerClass}
                        ref={modal => (this.modalNgo = modal)}
                        style={{
                            top: `${topModalDetail}px`
                        }}
                    >
                        {NGOdetail}
                    </div>
                    <div className={classModal}>
                        <div className={containerFiltersBoxesClass}>
                            <div className="ngo-modal-searcher__content-title">
                                <h3 className="ngo-modal-searcher__content-title--text">
                                    <FormattedText value="ngoModal-title" />
                                </h3>
                                <div className="ngo-modal-searcher__close-button">
                                    <OKIconTask
                                        activeHover={false}
                                        icon="icon-cerrar"
                                        onClick={() => this.openModalNGO()}
                                        style="default"
                                        type="circle"
                                    />
                                </div>
                            </div>
                            {filters}
                            <div className="col-xs-12 col-md-8 col-lg-9 ngo-modal-searcher__foundation-box-container">
                                {inputSearch}
                                {NGOboxes}
                            </div>
                        </div>
                        <div className={bottomMessageClass}>
                            <FormattedText value="ngoModal-bottomMessage" />
                        </div>
                    </div>
                </ModalCustom>
            </div>
        );
    }
}

NGOModalSearcher.defaultProps = {
    showButton: true,
    openModal: false
};

NGOModalSearcher.propTypes = {
    showButton: PropTypes.bool.isRequired,
    changeCharityFoundation: PropTypes.func,
    typeNGOModal: PropTypes.string,
    openModal: PropTypes.bool.isRequired,
    closeModal: PropTypes.func,
    charityFoundations: PropTypes.array,
};
